import React from 'react';
import { toArabicNumerals } from '../../utils/arabicNumbers';

const MetricCard = React.memo(function MetricCard({
  title,
  value,
  change,
  changeType,
  icon,
  subtitle,
  isArabic
}) {
  // Determine change color based on type
  const getChangeColor = () => {
    if (!change || changeType === 'neutral') return 'text-gray-500';
    return changeType === 'increase' || change > 0 ? 'text-green-600' : 'text-red-600';
  };

  // Format change display
  const formatChange = () => {
    if (!change) return null;
    const sign = change > 0 ? '+' : '';
    const percentage = `${sign}${change.toFixed(1)}%`;
    return isArabic ? toArabicNumerals(percentage, isArabic) : percentage;
  };

  return (
    <div
      className="bg-white rounded-xl p-4 md:p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
      dir={isArabic ? 'rtl' : 'ltr'}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <p className="text-gray-500 text-xs md:text-sm font-medium uppercase mb-2">
            {title}
          </p>
        </div>
        {icon && (
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-brand-light flex items-center justify-center ml-3">
            {typeof icon === 'string' ? (
              <span className="text-brand-orange text-xl">{icon}</span>
            ) : (
              <span className="text-brand-orange" style={{ fontSize: '20px' }}>
                {icon}
              </span>
            )}
          </div>
        )}
      </div>

      <div className="flex items-end justify-between">
        <div>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1">
            {isArabic && (typeof value === 'number' || (typeof value === 'string' && /[\d.,]/.test(value))) 
              ? toArabicNumerals(String(value), isArabic) 
              : value}
          </h3>
          {subtitle && (
            <p className="text-gray-600 text-xs md:text-sm">
              {subtitle}
            </p>
          )}
        </div>

        {change !== undefined && change !== null && (
          <div className={`flex items-center ${getChangeColor()} text-sm md:text-base font-semibold`}>
            <span>{formatChange()}</span>
            {changeType !== 'neutral' && (
              <svg
                className={`w-4 h-4 ml-1 ${isArabic ? 'mr-1 ml-0' : ''} ${change > 0 ? '' : 'transform rotate-180'}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
              </svg>
            )}
          </div>
        )}
      </div>
    </div>
  );
});

export default MetricCard;
